import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { openTaskModal, setProject } from './store';

@Injectable()
export class NgCore {
	public constructor(private readonly store: Store) {}

	public openTaskModal(): void {
		this.store.dispatch(openTaskModal());
	}

	public setProject(id: number, label: string): void {
		this.store.dispatch(
			setProject({
				projectId: id,
				projectLabel: label,
			})
		);
	}
}
